<ng-container *ngFor="let item of items; let i = index">

  <li *ngIf="!item.SubItems || item.SubItems.length == 0" class="{{item.Class}}">
    <a href="javascript:void(0);" routerLinkActive="active" routerLink="{{item.Url}}">
      <span> {{item.Title}}</span>
    </a>
  </li>

  <li *ngIf="item.SubItems && item.SubItems.length > 0" class="{{item.Class}}">
    <a data-bs-toggle="collapse" [attr.data-bs-target]="'#menu' + item.Id" role="button" aria-expanded="false"
      [attr.aria-controls]="'menu' + item.Id" href="#menu{{item.Id}}">
      <span> {{item.Title}}</span>
    </a>
    <ul id="menu{{item.Id}}" class="accordion-collapse collapse list-unstyled" [attr.data-bs-parent]="'#' + idparent"
      app-menu [items]="item.SubItems" [idparent]="'menu' + item.Id">
    </ul>

  </li>

  <!-- <ng-container *ngFor="let item of items; let i = index">

    <li *ngIf="!item.SubItems || item.SubItems.length == 0" class="{{item.Class}}">
      <a href="javascript:void(0);" routerLinkActive="active" routerLink="{{item.Url}}">
        <div class="item-menu"></div><span> {{item.Title}}</span>
      </a>
    </li>
  
    <li *ngIf="item.SubItems && item.SubItems.length > 0" class="{{item.Class}}">
      <a data-bs-toggle="collapse" [attr.data-bs-target]="'#menu' + item.Id" role="button" aria-expanded="false" [attr.aria-controls]="'menu' + item.Id" href="#menu{{item.Id}}">
        <span> {{item.Title}}</span>
      </a>
      <ul id="menu{{item.Id}}" class="accordion-collapse collapse list-unstyled" [attr.data-bs-parent]="'#' + idparent" app-menu [items]="item.SubItems" [idparent]="'menu' + item.Id">
      </ul>
  
    </li> -->